module.exports = __webpack_public_path__ + "static/img/logo.b2678067.png";